/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerLookupsQueryResponse, VistaControllerLookupsPathParams, VistaControllerLookups400, VistaControllerLookups401, VistaControllerLookups403, VistaControllerLookups404 } from "../../models/changeOrdersController/VistaControllerLookups";

function getVistaControllerLookupsUrl(id: VistaControllerLookupsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/potential-change-orders/${id}/vista/lookups` as const }  
  return res
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista/lookups}
 */
export async function vistaControllerLookups(id: VistaControllerLookupsPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<VistaControllerLookupsQueryResponse, ResponseErrorConfig<VistaControllerLookups400 | VistaControllerLookups401 | VistaControllerLookups403 | VistaControllerLookups404>, unknown>({ method : "GET", url : getVistaControllerLookupsUrl(id).url.toString(), ... requestConfig })  
  return res.data
}